<!--
 * @Description: 扫码错误页
 * @Author: XSYX
 * @Date: 2025-09-03 16:55:57
 * @LastEditors: XSYX
 * @LastEditTime: 2025-11-28 11:13:29
 * @FilePath: \smkp1\src\pages\error\index.vue
-->
<template>
	<div>
		<van-empty style="margin-top:10vh;" :image="errorImage" :description="$route.query.msg">
			<!-- <p style="color: #999; font-size: 14px;padding: 0 10vw;">{{ $route.query.msg }}</p> -->
			<van-button class="x-button" round type="info" @click="goHome">返回</van-button>
		</van-empty>
	</div>
</template>

<script>
	import Vue from "vue";
	import { Empty, Button } from "vant";
  import errorImage from '@/assets/empty-image-error.png';

	Vue.use(Empty).use(Button);

	export default {
		name: "error",
		components: {},
		data() {
			return {
        errorImage
      };
		},
		methods: {
			formD(obj) {
				const formData = new URLSearchParams();
				Object.keys(obj).forEach((key) => {
					if (obj[key] instanceof Array) {
						obj[key].forEach((item) => {
							formData.append(key, item);
						});
						return;
					}
					formData.append(key, obj[key]);
				});
				return formData;
			},
			goHome() {
				const querys = this.$route.query;
				delete querys.msg;
				querys.back = 1;
				Object.keys(querys).forEach(key => {
					if (querys[key]?.replace) querys[key] = querys[key].replace(new RegExp('#/', 'g'), '')
				});
				this.$router.push("/?" + this.formD(querys));
			},
		},
	};
</script>

<style lang="less" scoped>
	::v-deep p {
		text-align: center;
    color: #ff0000;
	}
	.x-button {
		position: fixed;
		bottom: 20vh;
		left: 25vw;
		width: 50vw;
		margin-top: 30px;
	}
</style>
